import React from "react";
import { DatePicker, DateTimePicker } from "@progress/kendo-react-dateinputs";
import { DropDownList, MultiSelect } from "@progress/kendo-react-dropdowns";
import { TimePickerComponent } from "@syncfusion/ej2-react-calendars";

const Operators = {
    Number: [
        "Equal to",
        "Not equal to",
        "Greater than",
        "Greater than or equal to",
        "Less than",
        "Less than or equal to",
        "Between",
        // "Positive",
        // "Negative"
    ],
    "State Field": [
        "Equal to",
        "Not equal to",
        "In",
        "Not in"
    ],
    DateTime: [
        "Equal to",
        "Not equal to",
        "Greater than",
        "Greater than or equal to",
        "Less than",
        "Less than or equal to",
        "Between",
        "Days selected"
    ],
    Tags: [
        "Equal to",
        "In"
    ],
    "Picklist String": [
        "Equal to",
        "Not equal to",
        "In",
        "Not in"
    ],
    Boolean: [
        "Equal to",
        "Not equal to"
    ]
};

const colorOptions = [
    "Fill color",
    "Text color"
];

const colorPaletteSettings = {
    palette: [
        "#222222", "#292e6b", "#009ccc", "#00643a", "#339947", "#fbbc3d",
        "#db552c", "#7f1725", "#ec008c", "#5c197b", "#51399f", "#444444",
        "#1b478b", "#43b4d5", "#207752", "#60af49", "#fbd144", "#e87025",
        "#b20b1e", "#ef33a3", "#71338d", "#6951aa", "#666666", "#0d60ab",
        "#86cdde", "#56987d", "#8dc54b", "#fbe74b", "#f58b1f", "#e60017",
        "#f266ba", "#9260a1", "#8874c2", "#888888", "#007acc", "#c9e7e7",
        "#7caf9a", "#a8ce4b", "#fbfd52", "#f7a24b", "#eb3345", "#f599d1",
        "#ae88b9", "#aa9cdf", "#aaaaaa", "#3f9bd8", "#d6eded", "#9cc3b2",
        "#c3d84c", "#fcfd7d", "#f9b978", "#f06673", "#f9cce8", "#c7abd0",
        "#c0b6e9", "#cccccc", "#7fbce5", "#e4f3f3", "#bfd8cd", "#d7e587",
        "#fcfea8", "#fbd0a5", "#f599a2", "#fbddef", "#e0cae7", "#dad4f7"
    ],
    columns: 11,
    tileSize: 16,
};

export const TextboxSingleSelect = ({ condition1, onChangeCondition1 }) => {
    return (
        <div className="col-5">
            <input
                type="text"
                className="form-control"
                value={condition1}
                onChange={(e) => onChangeCondition1(e.target.value)}
            />
        </div>
    );
};

export const PositiveNegative = () => {
    return <div className="col-5"></div>;
};

export const NumberSingleSelect = ({ condition1, onChangeCondition1 }) => {
    return (
        <div className="col-5">
            <input type="number" className="form-control" value={condition1} onChange={(e) => onChangeCondition1(e.target.value)} />
        </div>
    );
};

export const NumberMultiSelect = ({ condition1, condition2, onChangeCondition1, onChangeCondition2 }) => {
    return (
        <>
            <div className="col-3">
                <input type="number" className="form-control" value={condition1} onChange={(e) => onChangeCondition1(e.target.value)} />
            </div>
            <div className="col-1">
                <label className="col-form-label">and</label>
            </div>
            <div className="col-3">
                <input type="number" className="form-control" value={condition2} onChange={(e) => onChangeCondition2(e.target.value)} />
            </div>
        </>
    );
};

export const DropdownSingleSelect = ({ data, condition1, onChangeCondition1 }) => {
    return (
        <div className="col-5">
            <DropDownList
                data={data}
                value={condition1}
                onChange={(e) => onChangeCondition1(e.target.value)}
            />
        </div>
    );
};

export const DropdownMultiSelect = ({ data, condition1, onChangeCondition1, allowCustom, placeholder }) => {
    return (
        <div className="col-12 mt-3 custom-tag">
            <MultiSelect
                data={data}
                onChange={(e) => onChangeCondition1(e.target.value)}
                value={condition1}
                allowCustom={allowCustom}
                placeholder={placeholder}
            />
        </div>
    );
};

export const DatePickerSingleSelect = ({ condition1, onChangeCondition1 }) => {
    let value = getDateValue(condition1);
    return (
        <div className="col-5">
            <DatePicker format={"MM-dd-yyyy"} value={value} onChange={(e) => onChangeCondition1(e.target.value)} />
        </div>
    );
};

export const DatePickerMultiSelect = ({ condition1, condition2, onChangeCondition1, onChangeCondition2 }) => {

    let value1 = getDateValue(condition1)
    let value2 = getDateValue(condition2);

    return (
        <div className="row mt-3">
            <div className="col-5">
                <DatePicker format={"MM-dd-yyyy"} value={value1} onChange={(e) => onChangeCondition1(e.target.value)} />
            </div>
            <div className="col-2">
                <label className="col-form-label">and</label>
            </div>
            <div className="col-5">
                <DatePicker format={"MM-dd-yyyy"} value={value2} onChange={(e) => onChangeCondition2(e.target.value)} />
            </div>
        </div>
    );
};

export const TimePickerSingleSelect = ({ condition1, onChangeCondition1 }) => {

    let dateValue = new Date();
    try {
        dateValue = new Date(condition1);
        if (isNaN(dateValue)) throw new Error("Invalid Date");
    } catch (e) {
        dateValue = new Date();
        dateValue.setHours(10);
        dateValue.setMinutes(0);
    }

    return (
        <div className="col-5">
            <TimePickerComponent
                value={dateValue}
                change={e => onChangeCondition1(e.value)}
                format={'h:mm aa'}
                strictMode={true}
                openOnFocus={true}
                showClearButton={false}
            />
        </div>
    );
};

export const TimePickerMultiSelect = ({ condition1, condition2, onChangeCondition1, onChangeCondition2 }) => {

    let dateValue1 = new Date(condition1);
    let dateValue2 = new Date(condition2);

    if (!condition1) {
        dateValue1 = new Date();
        dateValue1.setHours(10);
        dateValue1.setMinutes(0);
    }

    if (!condition2) {
        dateValue2 = new Date();
        dateValue2.setHours(12);
        dateValue2.setMinutes(0);
    }

    return (
        <div className="row mt-3">
            <div className="col-5">
                <TimePickerComponent
                    value={dateValue1}
                    change={(e) => onChangeCondition1(e.value)}
                    format={'h:mm aa'}
                    strictMode={true}
                    openOnFocus={true}
                    showClearButton={false}
                />
            </div>
            <div className="col-2">
                <label className="col-form-label">and</label>
            </div>
            <div className="col-5">
                <TimePickerComponent
                    value={dateValue2}
                    change={(e) => onChangeCondition2(e.value)}
                    format={'h:mm aa'}
                    strictMode={true}
                    openOnFocus={true}
                    showClearButton={false}
                />
            </div>
        </div>
    );
};

export const DateTimePickerSingleSelect = ({ condition1, onChangeCondition1 }) => {

    const value = getDateValue(condition1);
    return (
        <div className="col-5">
            <DateTimePicker format={"MM-dd-yyyy HH:mm"} value={value} onChange={(e) => onChangeCondition1(e.target.value)} />
        </div>
    );
};

export const DateTimePickerMultiSelect = ({ condition1, condition2, onChangeCondition1, onChangeCondition2 }) => {

    const value1 = getDateValue(condition1);
    const value2 = getDateValue(condition2);

    return (
        <div className="row mt-3">
            <div className="col-5">
                <DateTimePicker format={"MM-dd-yyyy HH:mm"} value={value1} onChange={(e) => onChangeCondition1(e.target.value)} />
            </div>
            <div className="col-2">
                <label className="col-form-label">and</label>
            </div>
            <div className="col-5">
                <DateTimePicker format={"MM-dd-yyyy HH:mm"} value={value2} onChange={(e) => onChangeCondition2(e.target.value)} />
            </div>
        </div>
    );
};

export const getOperators = (attributeType) => Operators[attributeType] || [];
export const getColorOptions = () => colorOptions;
export const getColorPaletteSettings = () => colorPaletteSettings;

const getDateValue = (value) => {
    if (value === "") return new Date();
    if (typeof value === "string") return new Date(value);
    return value;
}